module.exports = __webpack_public_path__ + "static/media/TrueNorth_selectvars_thumb.36e8164b.png";